import React from 'react'
import { 
  EmojiDropdownOptions, 
  LengthDropdownOptions,
  ToneDropdownOptions,
  LanguageDropdownOptions,
  FormatTypeOptions,
  ComplexityDropdownOptions,
  PerspectiveDropdownOptions,
  CreativityDropdownOptions
} from '../../rex/constants'

interface AITextSettingsCellProps {
  dataItem: {
    options: any
  }
}

const getEmojiLabel = (value: number): string => {
  const emojiOption = EmojiDropdownOptions.find(option => option.value === value)
  return emojiOption ? String(emojiOption.key) : 'Unknown'
}

const getLengthLabel = (value: number): string => {
  const lengthOption = LengthDropdownOptions.find(option => option.value === value)
  return lengthOption ? String(lengthOption.key) : value.toString()
}

const getToneLabel = (value: string): string => {
  const toneOption = ToneDropdownOptions.find(option => option.value === value)
  return toneOption ? String(toneOption.key) : value
}

const getLanguageLabel = (value: string): string => {
  const languageOption = LanguageDropdownOptions.find(option => option.value === value)
  return languageOption ? String(languageOption.key) : value
}

const getFormatLabel = (value: string): string => {
  const formatOption = FormatTypeOptions.find(option => option.value === value)
  return formatOption ? String(formatOption.key) : value
}

const getComplexityLabel = (value: string): string => {
  const complexityOption = ComplexityDropdownOptions.find(option => option.value === value)
  return complexityOption ? String(complexityOption.key) : value
}

const getPerspectiveLabel = (value: string): string => {
  const perspectiveOption = PerspectiveDropdownOptions.find(option => option.value === value)
  return perspectiveOption ? String(perspectiveOption.key) : value
}

const getCreativityLabel = (value: string): string => {
  const creativityOption = CreativityDropdownOptions.find(option => option.value === value)
  return creativityOption ? String(creativityOption.key) : value
}

export const AITextSettingsCell = ({ dataItem }: AITextSettingsCellProps) => {
  try {
    const options = typeof dataItem.options === 'string' ? JSON.parse(dataItem.options) : dataItem.options
    if (!options) {
      return <span>-</span>
    }

    const settings = []
    if (options.tone) settings.push(`Tone: ${getToneLabel(options.tone)}`)
    if (options.length) settings.push(`Length: ${getLengthLabel(options.length)}`)
    if (options.language) settings.push(`Language: ${getLanguageLabel(options.language)}`)
    if (options.format) settings.push(`Format: ${getFormatLabel(options.format)}`)
    if (options.complexity) settings.push(`Complexity: ${getComplexityLabel(options.complexity)}`)
    if (options.perspective) settings.push(`Perspective: ${getPerspectiveLabel(options.perspective)}`)
    if (options.creativity) settings.push(`Creativity: ${getCreativityLabel(options.creativity)}`)
    if (typeof options.emoji !== 'undefined') {
      settings.push(getEmojiLabel(options.emoji))
    }

    const result = settings.length > 0 ? settings.join(' | ') : '-'
    return <td><div className="ai-text-settings-cell">{result}</div></td>
  } catch (e) {
    return <span>Error parsing settings</span>
  }
}